export const SIDEBAR_WIDTH = 280
export const SIDEBAR_WIDTH_PX = `${SIDEBAR_WIDTH}px`
export const NAVBAR_HEIGHT = 60
export const NAVBAR_HEIGHT_PX = `${NAVBAR_HEIGHT}px`